import { Grid, Typography } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import "../../../styles/home/How.scss";
import { Accordion } from "../../utils/Accordion";
import { useTranslation } from "react-i18next";
import { FirebaseContext } from "../../Providers/FirebaseProvider";

export const How = () => {
	const { t } = useTranslation(["landing"]);
	const elementRef = useRef(null);
	const [accordionOpen, setAccordionOpen] = useState<boolean | null>(null);
	const [animationPlayed, setAnimationPlayed] = useState<boolean>(false);
	const { myStorageUrl } = useContext(FirebaseContext);

	useEffect(() => {
		const handleMouseMovement = (e) => {
			const rect = e.target.getBoundingClientRect();
			const mouseX = e.clientX - rect.left;
			const mouseY = e.clientY - rect.top;

			e.target.style.setProperty("--mouse-x", `${mouseX}deg`);
			e.target.style.setProperty("--mouse-y", `${mouseY}deg`);
		};
		const panel = document.querySelector("#leaderboar-image");

		panel.addEventListener("mousemove", handleMouseMovement);

		return () => {
			panel.removeEventListener("mousemove", handleMouseMovement);
		};
	}, []);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					/**Make sure that the timeout time is equal to the animation time */
					if (entry.isIntersecting) {
						if (!entry.target.classList.contains("appear-from-right")) {
							entry.target.classList.add("appear-from-right");
							setTimeout(() => {
								setAnimationPlayed(true);
							}, 2000);
							observer.unobserve(entry.target);
						}
					} else if (false) {
						if (entry.target.classList.contains("appear-from-right")) {
							entry.target.classList.add("disappear-from-right");
							entry.target.classList.remove("appear-from-right");
							setTimeout(() => {
								setAnimationPlayed(false);
								entry.target.classList.remove("disappear-from-right");
							}, 2000);
							observer.unobserve(entry.target);
						}
					}
				});
			},
			{ threshold: 0.5 }
		);

		if (elementRef.current) {
			observer.observe(elementRef.current);
		}

		return () => {
			if (elementRef.current) {
				observer.unobserve(elementRef.current);
			}
		};
	}, [animationPlayed]);

	const [textAnimation, setTextAnimation] = useState<boolean>(false);
	const textContainerRef = useRef(null);
	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					/**Make sure that the timeout time is equal to the animation time */
					if (entry.isIntersecting) {
						if (!entry.target.classList.contains("appear-from-bottom")) {
							entry.target.classList.add("appear-from-bottom");
							setTimeout(() => {
								setTextAnimation(true);
							}, 2000);
							observer.unobserve(entry.target);
						}
					} else if (false) {
						if (entry.target.classList.contains("appear-from-bottom")) {
							entry.target.classList.add("disappear-from-bottom");
							entry.target.classList.remove("appear-from-bottom");
							setTimeout(() => {
								setTextAnimation(false);
								entry.target.classList.remove("disappear-from-bottom");
							}, 2000);
							observer.unobserve(entry.target);
						}
					}
				});
			},
			{ threshold: 0.5 }
		);

		if (textContainerRef.current) {
			observer.observe(textContainerRef.current);
		}

		return () => {
			if (textContainerRef.current) {
				observer.unobserve(textContainerRef.current);
			}
		};
	}, [textAnimation]);

	const groupRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const accordionButton = document.getElementById("accordion-how-button");
		const group = groupRef.current;

		const layout = () => {
			group.classList.toggle("accordion-text-open");
		};
		accordionButton.addEventListener("click", layout);
		return () => {
			if (accordionButton) {
				accordionButton.removeEventListener("click", layout);
			}
		};
	}, []);

	const handleClick = () => {
		document.getElementById('landing-signup-container').scrollIntoView({ behavior: 'smooth' });
	};

	return (
		<>
			<Grid container id="how-container" justifyContent="center" alignItems="center">
				<Grid item xs={12} sm={10}>
					<Grid container justifyContent="center" alignItems="center" sx={{ flexDirection: { xs: "column-reverse", sm: "row" } }}>
						<Grid item xs={10} sm={6} id="how-text-container" ref={textContainerRef}>
							<Typography variant="h3" className="section-text">
								{t("how.title")}
							</Typography>
							<div className="container-how-call-to-action" id="container-how-call-to-action" ref={groupRef}>
								<Accordion
									id="accordion-how"
									accordionActionElement={<Typography className="accordion-text">{t("discover.more")}</Typography>}
									removeTitle={true}
									setAccordionOpen={setAccordionOpen}
									accordionOpen={accordionOpen}
								>
									<Typography className="accordion-content-text">{t("how.accordion")}</Typography>
								</Accordion>
								<button className="button-landing join-button" onClick={handleClick}>
									{t("button.join.us")}
								</button>
							</div>
						</Grid>
						<Grid item xs={10} sm={6} className="container-how-image" ref={elementRef} id="how-image-container" alignSelf="flex-start">
							<img
								id="leaderboar-image"
								className="leaderboard-image"
								src={`${myStorageUrl}images/landing/leaderboard_image.png`}
								alt="Depth Image"
							/>
							<div id="first-bubble-background"></div>
							<div id="second-bubble-background"></div>
							<div id="third-bubble-background"></div>
							<div id="fourth-bubble-background"></div>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};
